module.exports = __webpack_public_path__ + "static/media/29ADMSPC22.6a77cc04.jpg";